import { core } from '@/core'
import Basic from '@basic'
import compile from '@/core/compile'
import { OfficeItem } from '@bag'

const restore = {
  read(el, tar) {
    const temp = el.find('template')[0].content.querySelectorAll('*')
    tar.slot = []
    return Array.from(temp).map((node) => {
      if (node.nodeType === 1) {
        return this.block(node, tar)
      }
    })
  },
  block(node, tar) {
    if (node.tagName) {
      const arr = ['start', 'end']
      const clazz = node.tagName.toLowerCase()
      const text = node.textContent
      const content = this.content(text, tar)
      const div = $('<div></div>')
      div.addClass(`file-row__${clazz}`)
      const index = $(node).attr('cell')
      index && div.attr('name', `file-${index}`)
      div.append(content)
      if (clazz === 'slot') {
        const slot = div
        const id = $(node).attr('to')
        tar.slot.push({ id, slot })
      }
      return div
    }
  },
  content(text, tar) {
    const reg = /\{\{(.*?)\}\}/gi
    let arr
    while ((arr = reg.exec(text)) !== null) {
      const info = arr[1]
      const infos = info.split('|').map((x) => x.trim())
      const temp = this.tempZone(infos[0], infos[1], tar)
      text = text.replace(arr[0], temp)
    }
    return text
  },
  tempZone(name, opt, tar) {
    const placeholder = ''
    const symbol = tar.settings.symbol || ''
    let temp = `<input type="textarea" name="${name}" symbol="${symbol}" placeholder="${placeholder}" class="file-text" style="100px;"></input>`
    if (opt) {
      const filter = tar.settings.filter
      const option =
        filter && $.type(filter[opt]) === 'function' && filter[opt]()
      if (option) {
        const attr = compile.attrString(option)
        temp = `<input symbol="${symbol}" name=${name} ${attr} >`
      }
    }
    return temp
  },
}

const util = {
  pullComponents(opt, tar, temp) {
    const objs = {}
    Array.from(temp).map((template) => {
      const tem = $(template).find('input[name]')
      Array.from(tem).map((params) => {
        const option = compile.getOption(params, tar.settings.codeContent)
        const name = option.name
        const item = new OfficeItem(option)
        objs[name] = item
        $(params).after(item.unit).detach()
      })
    })
    return objs
  },
  tabIndex(opt, tar) {
    const input = tar.$el.find('input,textarea')
    Array.from(input).map((node, i) => {
      $(node).attr('tabIndex', i + 1)
    })
  },
  slot(opt, tar) {
    tar.slot.map(({ slot, id }) => {
      slot.append($(`#${id}`))
    })
  },
  template: {
    table(opt, tar, doms) {
      const content = $('<div class="file-content"></div>')
      const table = $(
        '<table cellspacing="0" cellpadding="0" border="1" class="file-table"></table>'
      )
      const colgroup = $('<colgroup></colgroup>')
      const cols = opt.cols
      cols.forEach((item) => {
        const col = $(`<col width="${item}">`)
        colgroup.append(col)
      })
      table.append(colgroup)
      const tbody = this.tbody(opt, tar, doms)
      table.append(tbody)
      content.append(table)
      return content
    },
    form(opt, tar, doms) {
      const content = $('<form class="file-content"></form>')
      doms.map((node) => {
        // 同行
        if (
          node.hasClass('file-row__start') ||
          node.hasClass('file-row__end')
        ) {
          let block = tar.block
          if (!block) {
            block = tar.block = $('<div class="file-row__row"></div>')
            content.append(block)
          }
          block.append(node)
        } else {
          tar.block = null
          content.append(node)
        }
      })
      return content
    },
    tbody(opt, tar, doms) {
      const tbody = $('<tbody></tbody>')
      const arr = tar.settings.rows
      let index = 0
      arr.forEach((trs) => {
        const tr = $('<tr></tr>')
        trs.forEach((tds) => {
          index += 1
          const [rowspan = 1, colspan = 1] = tds
          const td = $(
            `<td rowspan="${rowspan}" colspan="${colspan}" name="td_${index}"><div class="cell" name="cell_${index}"></div></td>`
          )
          tr.append(td)
        })
        tbody.append(tr)
      })
      doms.map((node) => {
        const name = $(node).attr('name')
        if (name && name.length > 4) {
          const index = name.substring(5)
          tbody.find(`[name=cell_${index}]`).append(node)
        }
      })
      return tbody
    },
    thead(opt, tar, doms) {
      const tbody = $('<thead></thead>')
      const arr = tar.settings.rows
      let index = 0
      arr.forEach((trs) => {
        const tr = $('<tr></tr>')
        trs.forEach((tds) => {
          index += 1
          const [rowspan = 1, colspan = 1] = tds
          const td = $(
            `<th rowspan="${rowspan}" colspan="${colspan}" name="td_${index}"><div class="cell" name="cell_${index}"></div></th>`
          )
          tr.append(td)
        })
        tbody.append(tr)
      })
      doms.map((node) => {
        const name = $(node).attr('name')
        if (name && name.length > 4) {
          const index = name.substring(5)
          tbody.find(`[name=cell_${index}]`).append(node)
        }
      })
      return tbody
    },
  },
  updater: {
    // 原生属性: name
    title(value, opt, tar, node) { },
    // 原生属性: name
    hide(value, opt, tar, node) {
      const objs = tar.objs
      for (const key in objs) {
        const item = objs[key]
        item.hide = value
      }
    },
    // 原生属性: disabled
    disabled(value, opt, tar, node) {
      const objs = tar.objs
      for (const key in objs) {
        const item = objs[key]
        item.disabled = value
      }
    },
    // 基本功能×: view
    view(value, opt, tar, node) {
      const objs = tar.objs
      for (const key in objs) {
        const item = objs[key]
        item.view = value
      }
    },
  },
}

export default class Office extends Basic {
  constructor(opt) {
    super(opt)
    this.$el = $(opt.selector)
    const def = {
      type: 'office', // office/tbody/table 样式
    }
    this.defaults = {
      disabled: false, // 基本功能: 禁用/启用
      view: false, // 基本功能: 查看/编辑
      hide: false, // 基本功能: 隐藏/显示
    }
    this.events = {}
    core.proxyApi(this) // 核心属性处理
    core.proxyEvent(this) // 核心事件处理
    this.settings = Object.assign({}, def, this.defaults, opt)
    this.init()
  }

  init() {
    let template
    const opt = this.settings
    const doms = restore.read(this.$el, this)
    const { type } = opt
    if (type === 'table') template = util.template.table(opt, this, doms)
    else if (type === 'tbody') template = util.template.tbody(opt, this, doms)
    else if (type === 'thead') template = util.template.thead(opt, this, doms)
    else template = util.template.form(opt, this, doms)
    const members = {}
    core.compileSymbol(template[0], members)
    this.members = members
    this.unit = template
    this.objs = util.pullComponents(opt, this, doms)
    core.update(util.updater, opt, this)
    util.tabIndex(opt, this)
    util.slot(opt, this)
  }

  destroy() {
    this.unit.empty().remove()
  }

  fill(data, ...res) {
    core.currySomething((objs, name) => {
      if (data) {
        const value = data[name] || ''
        const item = objs[name]
        item.value = value
      }
    })(this.objs)(res)
  }

  clearData(...res) {
    core.currySomething((objs, name) => {
      const item = objs[name]
      item.value = ''
    })(this.objs)(res)
  }

  getData() {
    const answer = {}
    Object.entries(this.objs).map((item) => {
      answer[item[0]] = item[1].value
    })
    return answer
  }

  disabledItem(...res) {
    core.currySomething((objs, name) => {
      const item = objs[name]
      item.disabled = true
    })(this.objs)(res)
  }

  enabledItem(...res) {
    core.currySomething((objs, name) => {
      const item = objs[name]
      item.disabled = false
    })(this.objs)(res)
  }

  viewable(...res) {
    core.currySomething((objs, name) => {
      const item = objs[name]
      item.view = true
    })(this.objs)(res)
  }

  editable(...res) {
    core.currySomething((objs, name) => {
      const item = objs[name]
      item.view = false
    })(this.objs)(res)
  }

  hideItem(...res) {
    core.currySomething((objs, name) => {
      const item = objs[name]
      item.hide = true
    })(this.objs)(res)
  }

  showItem(...res) {
    core.currySomething((objs, name) => {
      const item = objs[name]
      item.hide = false
    })(this.objs)(res)
  }

  hideSection(...res) {
    core.currySomething((objs, name) => {
      const item = objs[name]
      const section = item.unit.closest('[class^=file-row__]')
      section.hide()
    })(this.objs)(res)
  }

  showSection(...res) {
    core.currySomething((objs, name) => {
      const item = objs[name]
      const section = item.unit.closest('[class^=file-row__]')
      section.show()
    })(this.objs)(res)
  }

  reset(...res) {
    core.currySomething((objs, name) => {
      const item = objs[name]
      const obj = item.item
      if (obj.reset && $.type(obj.reset) === 'function') {
        obj.reset()
      }
    })(this.objs)(res)
  }
}
